export const getSelectedUnit = (units, selectedUnitId) => {
  return units.find(u => u.id === selectedUnitId);
}